import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { isDarkHex } from '../../util/_internal/colorDarkness.js';
import { Icon } from '../Icon/Icon.component.js';
import { propTypes, defaultProps } from './Avatar.types.js';
import styles from './Avatar.module.scss.js';

var Avatar = /** @class */ (function (_super) {
    __extends(Avatar, _super);
    function Avatar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderAvatar = function () {
            var _a = _this.props, photoUrl = _a.photoUrl, avatarColor = _a.avatarColor, initials = _a.initials;
            if (photoUrl) {
                return (React__default.createElement("img", { className: styles.Avatar_image, alt: initials, src: photoUrl }));
            }
            if (initials) {
                var fontClassName = isDarkHex(avatarColor)
                    ? styles.Avatar_initials___light
                    : styles.Avatar_initials___dark;
                return (React__default.createElement("div", { className: "" + styles.Avatar_background, style: { background: avatarColor } },
                    React__default.createElement("span", { className: styles.Avatar_initials + " " + fontClassName }, initials)));
            }
            return (React__default.createElement("div", { className: "" + styles.Avatar_background, style: { background: avatarColor } },
                React__default.createElement(Icon, { className: styles.Avatar_userIcon, name: "AccountIcon", alt: "user", size: 100 })));
        };
        return _this;
    }
    Avatar.prototype.render = function () {
        var _a = this.props, className = _a.className, size = _a.size, disabled = _a.disabled, status = _a.status, selected = _a.selected, onClick = _a.onClick;
        var sizeClass = styles["Avatar_size___" + size];
        var statusClass = styles["AvatarStatus___" + status];
        var selectedClass = selected ? styles.Avatar___selected : '';
        var disabledClass = disabled ? styles.Avatar___disabled : '';
        if (status === 'danger') {
            console.warn('"danger" has been replaced by "busy" and will be deprecated soon.');
        }
        return (React__default.createElement("div", { className: clsx(styles.Avatar, className || '', sizeClass, disabledClass, selectedClass), onClick: onClick, "data-testid": this.props['data-testid'] },
            this.renderAvatar(),
            status && (React__default.createElement("div", { className: "\n                        " + styles.AvatarStatus + "\n                        " + statusClass + "\n                    " }))));
    };
    Avatar.displayName = 'Avatar';
    Avatar.propTypes = propTypes;
    Avatar.defaultProps = __assign({}, defaultProps);
    return Avatar;
}(React__default.Component));

export { Avatar as default };
